
  import { Vue, Component, Prop } from "vue-property-decorator";
  import getDefaultImageName from "@/helpers/getDefaultImageName";
  import imgA from "@/components/icons/staffCardPlaceholdersNew/imgA.vue";
  import imgB from "@/components/icons/staffCardPlaceholdersNew/imgB.vue";
  import imgC from "@/components/icons/staffCardPlaceholdersNew/imgC.vue";
  import imgD from "@/components/icons/staffCardPlaceholdersNew/imgD.vue";
  import imgE from "@/components/icons/staffCardPlaceholdersNew/imgE.vue";
  import imgF from "@/components/icons/staffCardPlaceholdersNew/imgF.vue";
  import imgG from "@/components/icons/staffCardPlaceholdersNew/imgG.vue";
  import imgH from "@/components/icons/staffCardPlaceholdersNew/imgH.vue";
  import imgI from "@/components/icons/staffCardPlaceholdersNew/imgI.vue";
  import imgJ from "@/components/icons/staffCardPlaceholdersNew/imgJ.vue";
  import imgK from "@/components/icons/staffCardPlaceholdersNew/imgK.vue";
  import imgL from "@/components/icons/staffCardPlaceholdersNew/imgL.vue";
  import imgM from "@/components/icons/staffCardPlaceholdersNew/imgM.vue";
  import imgN from "@/components/icons/staffCardPlaceholdersNew/imgN.vue";
  import imgO from "@/components/icons/staffCardPlaceholdersNew/imgO.vue";
  import imgP from "@/components/icons/staffCardPlaceholdersNew/imgP.vue";
  import imgQ from "@/components/icons/staffCardPlaceholdersNew/imgQ.vue";
  import imgR from "@/components/icons/staffCardPlaceholdersNew/imgR.vue";
  import imgS from "@/components/icons/staffCardPlaceholdersNew/imgS.vue";
  import imgT from "@/components/icons/staffCardPlaceholdersNew/imgT.vue";
  import imgU from "@/components/icons/staffCardPlaceholdersNew/imgU.vue";
  import imgV from "@/components/icons/staffCardPlaceholdersNew/imgV.vue";
  import imgW from "@/components/icons/staffCardPlaceholdersNew/imgW.vue";
  import imgX from "@/components/icons/staffCardPlaceholdersNew/imgX.vue";
  import imgY from "@/components/icons/staffCardPlaceholdersNew/imgY.vue";
  import imgZ from "@/components/icons/staffCardPlaceholdersNew/imgZ.vue";

  @Component({
    components: {
      imgA,
      imgB,
      imgC,
      imgD,
      imgE,
      imgF,
      imgG,
      imgH,
      imgI,
      imgJ,
      imgK,
      imgL,
      imgM,
      imgN,
      imgO,
      imgP,
      imgQ,
      imgR,
      imgS,
      imgT,
      imgU,
      imgV,
      imgW,
      imgX,
      imgY,
      imgZ,
    },
  })
  export default class DefaultProjectImage extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;

    get defaultImageComponentName(): string {
      return getDefaultImageName(this.title);
    }
  }
